import { 
    NavigationAction,
    NavigationState,
    NavigationPaths,
    LOAD_PATH_SCHEME,
    SET_HREF_DATA,
    SET_ACTIVE_TAB
} from "./types";
import qs from 'query-string';
import { pageGroups, pagePaths } from "../../settings/pages";

// ------ STATE ------ //

const initialState: NavigationState = {
    href: {
        fullUrl: "",
        backendPath: [],
        frontendPath: [],
        query: {}
    },
    subPages: pagePaths,
    groups: pageGroups,
    currentSubPage: Object.keys(pagePaths)[0]
}

// ----- REDUCER ----- //

export default function navigationReducer(state = initialState, action: NavigationAction) : NavigationState
{
    switch(action.type)
    {
        case SET_HREF_DATA:
            return setHrefData(state, action.data);
        case LOAD_PATH_SCHEME:
            return loadPathScheme(state, action.scheme);
        case SET_ACTIVE_TAB:
            return setActiveTab(state, action.pageId, action.tabId);
        default:
            return state;
    }
}

// ----- ACTIONS ----- //

function setHrefData(state: NavigationState, location: Location) : NavigationState
{
    let pages = Object.values(state.subPages);
    let subs = decodeURIComponent(location.pathname).split("/");
    let urlHashAndParams = decodeURIComponent(location.hash).split("?");
    
    let hash = urlHashAndParams.length > 0 ? urlHashAndParams[0] : "";
    let query = urlHashAndParams.length > 1 ? urlHashAndParams[urlHashAndParams.length-1] : "";
    let queryObj = qs.parse(query);

    let frontendList = hash.split("/").filter((value)=>(value!==""&&value!=="#"));
    let backendList = subs.filter((value)=>(value!==""));
    let currentHashRoute = "/"+frontendList.join("/");
    return  {
        ...state,
        href: {
            fullUrl: decodeURIComponent(window.location.href),
            frontendPath: frontendList,
            backendPath: backendList,
            query: {...queryObj}
        },
        currentSubPage: (pages.find(page => page.url === currentHashRoute) ?? pages[0]).id
    }
}

function loadPathScheme(state: NavigationState, scheme: NavigationPaths) : NavigationState
{
    return {
        ...state,
        subPages: {
            ...state.subPages,
            ...scheme
        }
    }
}

function setActiveTab(state: NavigationState, pageId: string, tabId: string)
{
    const validRequest = state.subPages.hasOwnProperty(pageId);
    return validRequest ? {
        ...state,
        subPages: {
            ...state.subPages,
            [pageId]: {
                ...state.subPages[pageId],
                currentTab: tabId
            }
        }
    } : state;
}

export function loadNavigation(state: NavigationState, location: Location)
{
    return new Promise<NavigationState>((resolve, reject) => {
        resolve(setHrefData(state, location));
    });
}

// -------------------- //